// Next Steps section form field enum
export enum NextStepsFormField {
  FINAL_NOTES = 'nextSteps/finalNotes',
  QUALIFICATION_STATUS = 'nextSteps/qualificationStatus',
  REQUESTED_DOCS = 'nextSteps/requestedDocs',
  SPECIFIC_NEEDS_FOR_DOCS = 'nextSteps/specificNeedsForDocs',
  REQUEST_QA = 'nextSteps/requestQA'
}
